import { render, staticRenderFns } from "./deletion-info.vue?vue&type=template&id=de990700"
import script from "./deletion-info.vue?vue&type=script&lang=js"
export * from "./deletion-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports